import React from 'react';
import styled from 'styled-components';

export default ({ children, ...props }) => (
  <CollectionSubMenuTitle {...props}>{children}</CollectionSubMenuTitle>
);

const CollectionSubMenuTitle = styled.h3`
  display: flex;
  align-items: center;

  margin-top: 0;
  margin-bottom: 1rem;
  margin-left: .875rem;
`;
